import { Component, Input} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TelemetryEventName } from '@app/@shared/enums/telemetry-event-name';
import { AlertMessages } from '@app/@shared/models/alert';
import { AlertService } from '@app/@shared/services/alert/alert-service';
import { IncentiveOptions, IncentiveReport } from '@app/@shared/services/incentive/incentive.models';
import { IncentiveService } from '@app/@shared/services/incentive/incentive.service';
import { MyLibraryService } from '@app/@shared/services/my-library/my-library.service';
import { TelemetryService } from '@app/@shared/services/telemetry-service';
import { FavoriteContentType } from '@app/my-library/models/my-library.models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { of } from 'rxjs';
import { catchError, concatMap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-general-incentive-modal',
  templateUrl: './general-incentive-modal.component.html',
  styleUrl: './general-incentive-modal.component.scss'
})
export class GeneralIncentiveModalComponent {

  @Input() props: IncentiveOptions;

  report: IncentiveReport;
  disabled = false;

  constructor(
    public modal: NgbActiveModal,
    private incentiveService: IncentiveService,
    private myLibraryService: MyLibraryService,
    private alertService: AlertService,
    private telemetryService: TelemetryService,
    private router: Router,
    private route : ActivatedRoute,
  ) {}

  onClickButton() {
    this.disabled = true;
    this.incentiveService.chooseFreeReport(this.report.internal_id).pipe(
      concatMap(() => this.myLibraryService.addToFavorites([this.report.internal_id], FavoriteContentType.ANALYSIS)),
      catchError((_err) => {
        this.alertService.error(AlertMessages.CHOOSE_FREE_REPORT_FAILED);
        return of(null);
      }),
      untilDestroyed(this)
    ).subscribe({
        next: () => {
          this.router.navigate(['analysis-view', this.report.code], { relativeTo: this.route })
        },
        complete: () => {
          if (this.report) {
            this.telemetryService.sendHeapEvent(TelemetryEventName.EVENT_HEAP_INCENTIVE_MODAL_ACEPTED, {
              "Product Name": this.report.name,
              "Product Code": this.report.code
            }).subscribe();
          }
          this.disabled = false;
          this.modal.dismiss();
        }
      });
  }
}
